export const HEADER_HEIGHT = 60;
export const NAVBAR_MOBILE_WIDTH = 300;
